import React from "react"
export const SelectColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column
  return (
    <select
      id="custom-select"
      className="form-select"
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="paid">Paid</option>
      <option value="failed">Fail</option>
      <option value="pending">Pending</option>
    </select>
  )
}
